/* eslint-disable no-underscore-dangle */
import React, {
  memo,
} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';

const defaultRecord = () => ({
  date: new Date().toJSON().slice(0, 10),
  order_amount: 0,
});

function RealEstatTablePart({
  data, options, onChange, readOnly, mode,
}) {
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage,
  } = useTablePart({
    data, options, onChange, readOnly, defaultRecord,
  });

  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      />
      <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {mode === 'land' && (
                <TableCell>
                  {fields.land.label}
                </TableCell>
              )}
              {mode === 'easement' && (
                <TableCell>
                  {fields.easement.label}
                </TableCell>
              )}
              {mode === 'realty' && (
                <TableCell>
                  {fields.realty.label}
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row) => (
              <Row
                actions={actions}
                row={row}
                readOnly={readOnly}
                fields={fields}
                key={row.id}
                active={activeRow === row.id}
                mode={mode}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

RealEstatTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  mode: PropTypes.oneOf(['land', 'easement', 'realty']).isRequired,
};

RealEstatTablePart.defaultProps = {
  readOnly: false,
};

export default memo(RealEstatTablePart);
